import { render } from "./copyright-link.vue?vue&type=template&id=2b2e8ca6"
import script from "./copyright-link.vue?vue&type=script&lang=js"
export * from "./copyright-link.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-footer/copyright-link.vue'],['render',render],['__file',"copyright-link.vue"]])

export default __exports__